import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadataCollection, FilterFieldProvider, FieldMetadataCollectionBuilder } from '@common/filter/filtering';
import { IRow, ITable } from '@common/models/table';
import { ArrayToFilterListItemBuilder, asDate, mapDate } from '@common/filter/services/array-to-filter-list-item-builder';


export class HeadLeaseWidgetFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(private readonly tableData: ITable,
    private readonly product: string) {

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);
    const optionBuilder = new ArrayToFilterListItemBuilder(tableData ? tableData.Rows : []);
    const sysOption = (s: string) => optionBuilder.forProperty(s, s, (x: IRow) => x[s]);

    sysOption('SystemHeadLeasePropertyRef');
    sysOption('SystemHeadLeaseRef');
    sysOption('SystemLandlordName');
    sysOption('SystemPropertyName');
    optionBuilder.add('SystemHeadLeaseTermStartDate', (x: any) => asDate(x.SystemHeadLeaseTermStartDate), mapDate('SystemHeadLeaseTermStartDate'));
    optionBuilder.add('SystemHeadLeaseTermEndDate', (x: any) => asDate(x.SystemHeadLeaseTermEndDate), mapDate('SystemHeadLeaseTermEndDate'));
    sysOption('SystemHeadLeasePassingRent');
    sysOption('SystemHeadLeaseAnnualSC');
    sysOption('SystemHeadLeaseLandlordRef');
    optionBuilder.add('SystemHeadLeaseLeaseDated', (x: any) => asDate(x.SystemHeadLeaseLeaseDated), mapDate('SystemHeadLeaseLeaseDated'));
    optionBuilder.add('SystemHeadLeaseNextReviewDate', (x: any) => asDate(x.SystemHeadLeaseNextReviewDate), mapDate('SystemHeadLeaseNextReviewDate'));
    optionBuilder.add('SystemNextOptionDate', (x: any) => asDate(x.SystemNextOptionDate), mapDate('SystemNextOptionDate'));
    sysOption('SystemNextOptionType');
    sysOption('SystemOptionBy');
    sysOption('SystemHeadLeaseTerminationStatus');
    sysOption('SystemHeadLeaseAlterationsPermitted');
    sysOption('SystemHeadLeaseAssignmentPermitted');
    sysOption('SystemHeadLeaseBreachStatus');
    sysOption('SystemHeadLeaseDefaultCurrencyCode');
    optionBuilder.add('SystemHeadLeaseFirstReviewDate', (x: any) => asDate(x.SystemHeadLeaseFirstReviewDate), mapDate('SystemHeadLeaseFirstReviewDate'));
    sysOption('SystemHeadLeaseLeaseTerm');
    sysOption('SystemHeadLeaseLt1987ActApplies');
    sysOption('SystemHeadLeaseOutside1954Act');
    sysOption('SystemHeadLeasePrivityApplies');
    optionBuilder.add('SystemHeadLeaseRenewalStartDate', (x: any) => asDate(x.SystemHeadLeaseRenewalStartDate), mapDate('SystemHeadLeaseRenewalStartDate'));
    sysOption('SystemHeadLeaseRenewed');
    sysOption('SystemHeadLeaseRespForBuildingInsurance');
    sysOption('SystemHeadLeaseRespForExtRepairs');
    sysOption('SystemHeadLeaseRespForIntRepairs');
    sysOption('SystemHeadLeaseRespForLorInsurance');
    sysOption('SystemHeadLeaseRespForPlateGlassIns');
    sysOption('SystemHeadLeaseRespForPlInsurance');
    sysOption('SystemHeadLeaseRespForRates');
    sysOption('SystemHeadLeaseRestrictiveCovenants');
    sysOption('SystemHeadLeaseReviewBasis');
    sysOption('SystemHeadLeaseReviewPattern');
    sysOption('SystemHeadLeaseSublettingPermitted');
    optionBuilder.add('SystemHeadLeaseTerminatedDate', (x: any) => asDate(x.SystemHeadLeaseTerminatedDate), mapDate('SystemHeadLeaseTerminatedDate'));
    sysOption('SystemHeadLeaseTurnoverRent');
    sysOption('SystemHoldingOver');
    sysOption('SystemLeaseTypeCode');
    sysOption('SystemPropertyStrungAddress');
    sysOption('SystemHeadLeaseVatOnRentApplies');
    sysOption('SystemHeadLeaseVatOnSCApplies');
    sysOption('SystemHeadLeaseScottishLease');
    sysOption('SystemHeadLeaseDemise');


    const options = optionBuilder.build();

    const addFilter = (label: string,
      optionsName: string,
      type: string,
      ops: string[]) => fieldMetaDataBuilder.add(label, optionsName, type, ops, options.get(optionsName));

      addFilter('Property Ref','SystemHeadLeasePropertyRef', 'number', FilterOperators.Scalar);
      addFilter('Head Lease Ref','SystemHeadLeaseRef', 'number', FilterOperators.Scalar);
      addFilter('Landlord Name','SystemLandlordName', 'string', FilterOperators.StringDefaults);
      addFilter('Property Name','SystemPropertyName', 'string', FilterOperators.StringDefaults);
      addFilter('Start Date','SystemHeadLeaseTermStartDate', 'date', FilterOperators.DateDefaults);
      addFilter('End Date','SystemHeadLeaseTermEndDate', 'date', FilterOperators.DateDefaults);
      addFilter('Passing Rent','SystemHeadLeasePassingRent', 'number', FilterOperators.Scalar);
      addFilter('Service Charge Amount','SystemHeadLeaseAnnualSC', 'number', FilterOperators.Scalar);
      addFilter('Landlord Ref','SystemHeadLeaseLandlordRef', 'number', FilterOperators.Scalar);
      addFilter('Lease Dated','SystemHeadLeaseLeaseDated', 'date', FilterOperators.DateDefaults);
      addFilter('Next Review Date','SystemHeadLeaseNextReviewDate', 'date', FilterOperators.DateDefaults);
      addFilter('Next Option Date','SystemNextOptionDate', 'date', FilterOperators.DateDefaults);
      addFilter('Next Option Type','SystemNextOptionType', 'string', FilterOperators.StringDefaults);
      addFilter('Option By','SystemOptionBy', 'string', FilterOperators.StringDefaults);
      addFilter('Termination Status','SystemHeadLeaseTerminationStatus', 'string', FilterOperators.StringDefaults);
      addFilter('Alterations Permitted','SystemHeadLeaseAlterationsPermitted', 'string', FilterOperators.StringDefaults);
      addFilter('Assignment Permitted','SystemHeadLeaseAssignmentPermitted', 'string', FilterOperators.StringDefaults);
      addFilter('Breach Status','SystemHeadLeaseBreachStatus', 'string', FilterOperators.StringDefaults);
      addFilter('Currency','SystemHeadLeaseDefaultCurrencyCode', 'string', FilterOperators.StringDefaults);
      addFilter('First Review Date','SystemHeadLeaseFirstReviewDate', 'date', FilterOperators.DateDefaults);
      addFilter('Lease Term','SystemHeadLeaseLeaseTerm', 'string', FilterOperators.StringDefaults);
      addFilter('1987 Act Applies','SystemHeadLeaseLt1987ActApplies', 'string', FilterOperators.StringDefaults);
      addFilter('Outside 1954 act','SystemHeadLeaseOutside1954Act', 'string', FilterOperators.StringDefaults);
      addFilter('Privity Applies','SystemHeadLeasePrivityApplies', 'string', FilterOperators.StringDefaults);
      addFilter('Renewal Start Date','SystemHeadLeaseRenewalStartDate', 'date', FilterOperators.DateDefaults);
      addFilter('Renewed','SystemHeadLeaseRenewed', 'string', FilterOperators.StringDefaults);
      addFilter('Buildings Insurance','SystemHeadLeaseRespForBuildingInsurance', 'string', FilterOperators.StringDefaults);
      addFilter('External Repairs','SystemHeadLeaseRespForExtRepairs', 'string', FilterOperators.StringDefaults);
      addFilter('Internal Repairs','SystemHeadLeaseRespForIntRepairs', 'string', FilterOperators.StringDefaults);
      addFilter('LOR Insurance','SystemHeadLeaseRespForLorInsurance', 'string', FilterOperators.StringDefaults);
      addFilter('Plate Glass Insurance','SystemHeadLeaseRespForPlateGlassIns', 'string', FilterOperators.StringDefaults);
      addFilter('PL Insurance','SystemHeadLeaseRespForPlInsurance', 'string', FilterOperators.StringDefaults);
      addFilter('Rates','SystemHeadLeaseRespForRates', 'string', FilterOperators.StringDefaults);
      addFilter('Restrictive Covenants','SystemHeadLeaseRestrictiveCovenants', 'string', FilterOperators.StringDefaults);
      addFilter('Review Basis','SystemHeadLeaseReviewBasis', 'string', FilterOperators.StringDefaults);
      addFilter('Review Pattern','SystemHeadLeaseReviewPattern', 'string', FilterOperators.StringDefaults);
      addFilter('Subletting Permitted','SystemHeadLeaseSublettingPermitted', 'string', FilterOperators.StringDefaults);
      addFilter('Terminated Date','SystemHeadLeaseTerminatedDate', 'date', FilterOperators.DateDefaults);
      addFilter('Turnover Rent','SystemHeadLeaseTurnoverRent', 'string', FilterOperators.StringDefaults);
      addFilter('Holding Over','SystemHeadLeaseTurnoverRent', 'string', FilterOperators.StringDefaults);
      addFilter('Lease Type','SystemLeaseTypeCode', 'string', FilterOperators.StringDefaults);
      addFilter('Property Address','SystemPropertyStrungAddress', 'string', FilterOperators.StringDefaults);
      addFilter('VAT on Rent Applies','SystemHeadLeaseVatOnRentApplies', 'string', FilterOperators.StringDefaults);
      addFilter('VAT on S/C Applies','SystemHeadLeaseVatOnSCApplies', 'string', FilterOperators.StringDefaults);
      addFilter('Scottish Lease','SystemHeadLeaseScottishLease', 'string', FilterOperators.StringDefaults);
      addFilter('Demise','SystemHeadLeaseDemise', 'string', FilterOperators.StringDefaults);
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }


}
